export const dataProtectionDocsUrl =
  'https://communications.spottedzebra.co.uk/knowledge-base/how-we-protect-your-diversity-inclusion-data';
